// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from 'src/apolloHooks';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type DevelopmentHolidayCard_AllProjectsQueryVariables = Types.Exact<{
  filter?: Types.InputMaybe<Types.ProjectFilter>;
}>;


export type DevelopmentHolidayCard_AllProjectsQuery = { __typename?: 'Query', projectsPage: { __typename?: 'ProjectsPageResult', entities: Array<
      | { __typename?: 'StandaloneProject', id: string, name: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Region', id: string, name: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Market', id: string, name: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Community', id: string, name: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Subdivision', id: string, name: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Lot', id: string, name: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Structure', id: string, name: string, features: Array<Types.ProjectFeature> }
      | { __typename?: 'Unit', id: string, name: string, features: Array<Types.ProjectFeature> }
    > } };

export type DevelopmentHolidayCard_Project_StandaloneProject_Fragment = { __typename?: 'StandaloneProject', id: string, name: string, features: Array<Types.ProjectFeature> };

export type DevelopmentHolidayCard_Project_Region_Fragment = { __typename?: 'Region', id: string, name: string, features: Array<Types.ProjectFeature> };

export type DevelopmentHolidayCard_Project_Market_Fragment = { __typename?: 'Market', id: string, name: string, features: Array<Types.ProjectFeature> };

export type DevelopmentHolidayCard_Project_Community_Fragment = { __typename?: 'Community', id: string, name: string, features: Array<Types.ProjectFeature> };

export type DevelopmentHolidayCard_Project_Subdivision_Fragment = { __typename?: 'Subdivision', id: string, name: string, features: Array<Types.ProjectFeature> };

export type DevelopmentHolidayCard_Project_Lot_Fragment = { __typename?: 'Lot', id: string, name: string, features: Array<Types.ProjectFeature> };

export type DevelopmentHolidayCard_Project_Structure_Fragment = { __typename?: 'Structure', id: string, name: string, features: Array<Types.ProjectFeature> };

export type DevelopmentHolidayCard_Project_Unit_Fragment = { __typename?: 'Unit', id: string, name: string, features: Array<Types.ProjectFeature> };

export type DevelopmentHolidayCard_ProjectFragment =
  | DevelopmentHolidayCard_Project_StandaloneProject_Fragment
  | DevelopmentHolidayCard_Project_Region_Fragment
  | DevelopmentHolidayCard_Project_Market_Fragment
  | DevelopmentHolidayCard_Project_Community_Fragment
  | DevelopmentHolidayCard_Project_Subdivision_Fragment
  | DevelopmentHolidayCard_Project_Lot_Fragment
  | DevelopmentHolidayCard_Project_Structure_Fragment
  | DevelopmentHolidayCard_Project_Unit_Fragment
;

export const DevelopmentHolidayCard_ProjectFragmentDoc = gql`
    fragment DevelopmentHolidayCard_Project on Project {
  id
  name
  features
}
    `;
export const DevelopmentHolidayCard_AllProjectsDocument = gql`
    query DevelopmentHolidayCard_AllProjects($filter: ProjectFilter) {
  projectsPage(filter: $filter) {
    entities {
      ...DevelopmentHolidayCard_Project
    }
  }
}
    ${DevelopmentHolidayCard_ProjectFragmentDoc}`;

/**
 * __useDevelopmentHolidayCard_AllProjectsQuery__
 *
 * To run a query within a React component, call `useDevelopmentHolidayCard_AllProjectsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDevelopmentHolidayCard_AllProjectsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDevelopmentHolidayCard_AllProjectsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useDevelopmentHolidayCard_AllProjectsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<DevelopmentHolidayCard_AllProjectsQuery, DevelopmentHolidayCard_AllProjectsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<DevelopmentHolidayCard_AllProjectsQuery, DevelopmentHolidayCard_AllProjectsQueryVariables>(DevelopmentHolidayCard_AllProjectsDocument, options);
      }
export function useDevelopmentHolidayCard_AllProjectsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<DevelopmentHolidayCard_AllProjectsQuery, DevelopmentHolidayCard_AllProjectsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<DevelopmentHolidayCard_AllProjectsQuery, DevelopmentHolidayCard_AllProjectsQueryVariables>(DevelopmentHolidayCard_AllProjectsDocument, options);
        }
// @ts-ignore
export function useDevelopmentHolidayCard_AllProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentHolidayCard_AllProjectsQuery, DevelopmentHolidayCard_AllProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentHolidayCard_AllProjectsQuery, DevelopmentHolidayCard_AllProjectsQueryVariables>;
export function useDevelopmentHolidayCard_AllProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentHolidayCard_AllProjectsQuery, DevelopmentHolidayCard_AllProjectsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<DevelopmentHolidayCard_AllProjectsQuery | undefined, DevelopmentHolidayCard_AllProjectsQueryVariables>;
export function useDevelopmentHolidayCard_AllProjectsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<DevelopmentHolidayCard_AllProjectsQuery, DevelopmentHolidayCard_AllProjectsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<DevelopmentHolidayCard_AllProjectsQuery, DevelopmentHolidayCard_AllProjectsQueryVariables>(DevelopmentHolidayCard_AllProjectsDocument, options);
        }
export type DevelopmentHolidayCard_AllProjectsQueryHookResult = ReturnType<typeof useDevelopmentHolidayCard_AllProjectsQuery>;
export type DevelopmentHolidayCard_AllProjectsLazyQueryHookResult = ReturnType<typeof useDevelopmentHolidayCard_AllProjectsLazyQuery>;
export type DevelopmentHolidayCard_AllProjectsSuspenseQueryHookResult = ReturnType<typeof useDevelopmentHolidayCard_AllProjectsSuspenseQuery>;
export type DevelopmentHolidayCard_AllProjectsQueryResult = ApolloReactCommon.QueryResult<DevelopmentHolidayCard_AllProjectsQuery, DevelopmentHolidayCard_AllProjectsQueryVariables>;